import { ProductTransaction, UpdateProductTransactionInput } from '../types/productTransaction';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product_transaction/list';
const IDS = '/api/product_transaction/ids';

const PROCESS = '/api/product_transaction/process';
const CANCEL = '/api/product_transaction/cancel';

export namespace ProductTransactionRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<ProductTransaction>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const process = async (payload: {
    data: UpdateProductTransactionInput[];
    statusId: string;
  }): Promise<ProductTransaction[]> => {
    return (await http.post(PROCESS, payload)).data;
  };

  export const cancel = async (payload: { ids: string[] }): Promise<ProductTransaction[]> => {
    return (await http.post(CANCEL, payload)).data;
  };

  export const ids = async (payload: {
    ids: string[];
    page: number;
  }): Promise<PaginatedResponse<ProductTransaction>> => {
    return (await http.post(IDS, payload)).data;
  };
}
